import config from '../../../../config';
import Request from '../../../Request';

export default function create(orderId, values, onSuccess, onFailure) {
  return Request.post(`${config.apiUrl}/orders/${orderId}/order_refunds`, { order_refund: values }, onSuccess, onFailure);
}